/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, {useEffect, useState, useCallback} from 'react';
import {useSelector} from 'react-redux';
// utils

// material
import { Page, Content} from '@insticator/insticator-ui';
import PageHeader from '../../../../material/structure/pageheader/pageheader';
import PageContent from '../../../../material/structure/pagecontent/pagecontent';

// styles
import injectSheet from 'react-jss';
import styles from './help_styles';


/* ========== ~~~~~~~~~~ PROFILE - HELP PAGE ~~~~~~~~~~ ========== */

const HelpPage = injectSheet(styles)((props) => {
    return (
        <Page name={'helpPage'}>
            <Content>
                <PageHeader title={'Settings'} subtitle={'Help'} />
                <PageContent>
                    <h3>Helpful links:</h3>
                        <ul className={`helpfulLinks`}>
                            <li><a href="https://documentation.insticator.com/docs" target="_new">COOL Media Documentation Portal</a></li>
                        </ul>
                </PageContent>
                
            </Content>
        </Page>
    );
});

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default HelpPage;